<div class="notificaciones-theme notif-nueva-page">
  <a routerLink="/notificaciones" class="notif-volver-link">
    <span aria-hidden="true">←</span>Volver a notificaciones
  </a>

  <h1 class="notif-heading" style="font-size:1.375rem;margin:0 0 0.25rem;">{{ tituloPantalla() }}</h1>
  <div class="mb-3" style="color:var(--notif-text-secondary);font-size:0.875rem;">{{ textoAyuda() }}</div>

  <form [formGroup]="form">
    <div class="mb-4">
      <label class="form-label">Nombre interno de la notificación</label>
      <input type="text" class="form-control notif-nombre-interno-input" formControlName="nombreInterno">
      <div class="form-text">Uso interno para identificar la notificación en el listado — el afiliado no lo ve.</div>
      @if (esInvalido('nombreInterno')) {
        <div class="text-danger small">El nombre interno es obligatorio.</div>
      }
    </div>

    <div class="notif-nueva-layout">
    <div class="notif-nueva-form">
      <div class="notif-card mb-3">
        <div class="notif-card-header">
          <span class="notif-step-num">1</span>
          <h2 class="notif-card-title">Audiencia</h2>
        </div>

        <div class="row g-3">
          <div class="col-12">
            <div class="d-flex flex-column gap-2">
              <label class="radio-card" [class.selected]="!esAudienciaFiltrada()">
                <input type="radio" class="visually-hidden" value="TODOS" formControlName="tipoAudiencia">
                <span class="radio-dot"><span class="radio-dot-fill"></span></span>
                <span class="radio-card-body">
                  <span class="radio-card-title">Enviar a todos</span>
                  <span class="radio-card-desc">Llega a toda la base de afiliados activos, sin distinción de rol ni perfil.</span>
                </span>
              </label>
              <label class="radio-card" [class.selected]="esAudienciaFiltrada()">
                <input type="radio" class="visually-hidden" value="FILTROS" formControlName="tipoAudiencia">
                <span class="radio-dot"><span class="radio-dot-fill"></span></span>
                <span class="radio-card-body">
                  <span class="radio-card-title">Aplicar filtros</span>
                  <span class="radio-card-desc">Segmentá por cobertura, rango etario, sexo y ubicación.</span>
                </span>
              </label>
            </div>
          </div>

          @if (esAudienciaFiltrada()) {
            <div class="col-12 col-md-6">
              <app-multi-select-dropdown
                label="Cobertura"
                [opciones]="catalogos.coberturas()"
                [seleccionados]="coberturaIds()"
                [todos]="coberturaTodos()"
                [deshabilitado]="form.disabled"
                (cambio)="onCoberturaCambio($event)" />
              @if (submitted() && coberturaInvalida()) {
                <div class="text-danger small">Elegí al menos una cobertura, o tildá Todos.</div>
              }
            </div>

            <div class="col-12 col-md-6">
              <label class="form-label">Sexo</label>
              <select class="form-select" formControlName="sexo">
                <option value="AMBOS">Ambos</option>
                <option value="FEMENINO">Femenino</option>
                <option value="MASCULINO">Masculino</option>
              </select>
            </div>

            <div class="col-12">
              <label class="form-label">Rango etario</label>
              <div class="notif-edad-rango" [class.disabled]="form.disabled">
                <span class="notif-edad-label">Desde</span>
                <input type="number" min="0" class="form-control notif-edad-input" formControlName="edadDesde">
                <span class="notif-edad-separador">—</span>
                <span class="notif-edad-label">Hasta</span>
                <input type="number" min="0" class="form-control notif-edad-input" formControlName="edadHasta">
              </div>
              @if (submitted() && edadInvalida()) {
                <div class="text-danger small">"Edad desde" no puede ser mayor que "Edad hasta".</div>
              }
            </div>

            <div class="col-12 col-md-6">
              <app-multi-select-dropdown
                label="Provincia"
                [opciones]="catalogos.provincias()"
                [seleccionados]="provinciaIds()"
                [todos]="provinciaTodos()"
                [deshabilitado]="form.disabled"
                (cambio)="onProvinciaCambio($event)" />
              @if (submitted() && provinciaInvalida()) {
                <div class="text-danger small">Elegí al menos una provincia, o tildá Todas.</div>
              }
            </div>

            <div class="col-12 col-md-6">
              <app-multi-select-dropdown
                label="Localidad"
                [opciones]="localidadOpciones()"
                [seleccionados]="localidadIds()"
                [todos]="localidadTodos()"
                [deshabilitado]="form.disabled || provinciaIds().length === 0"
                (cambio)="onLocalidadCambio($event)" />
              @if (catalogos.cargandoLocalidades()) {
                <div class="form-text">Cargando localidades...</div>
              }
              @if (submitted() && localidadInvalida()) {
                <div class="text-danger small">Elegí al menos una localidad, o tildá Todas.</div>
              }
            </div>
          }
        </div>
      </div>

      <div class="notif-card mb-3">
        <div class="notif-card-header">
          <span class="notif-step-num">2</span>
          <h2 class="notif-card-title">Mensaje</h2>
        </div>

        <div class="notif-subcard mb-3">
          <span class="notif-tag">Notificación push</span>
          <div class="notif-subcard-subtitle">Lo que el afiliado ve en la notificación del celular</div>

          <div>
            <label class="form-label">Título</label>
            <input type="text" class="form-control" maxlength="120" formControlName="titulo">
            <div class="d-flex justify-content-between gap-2">
              <div class="form-text">Es el título que ve el afiliado en la notificación push y en el pop-up.</div>
              <div class="form-text text-nowrap">{{ previewTitulo().length }}/120</div>
            </div>
            @if (esInvalido('titulo')) {
              <div class="text-danger small">El título es obligatorio (máx. 120 caracteres).</div>
            }
          </div>

          <div>
            <label class="form-label">Mensaje corto</label>
            <textarea class="form-control" rows="2" maxlength="180" formControlName="mensajeCorto"></textarea>
            <div class="d-flex justify-content-between gap-2">
              <div class="form-text">Al tocar la notificación, siempre abre el pop-up institucional.</div>
              <div class="form-text text-nowrap">{{ previewCorto().length }}/180</div>
            </div>
            @if (esInvalido('mensajeCorto')) {
              <div class="text-danger small">El mensaje corto es obligatorio (máx. 180 caracteres).</div>
            }
          </div>
        </div>

        <div class="notif-subcard">
          <span class="notif-tag">Mensaje del panel (pop-up)</span>
          <div class="notif-subcard-subtitle">Lo que ve el afiliado al abrir el pop-up institucional</div>

          <div>
            <label class="form-label">Mensaje ampliado</label>
            <textarea class="form-control" rows="4" maxlength="500" formControlName="mensajeAmpliado"></textarea>
            <div class="form-text text-end">{{ previewAmpliado().length }}/500</div>
            @if (esInvalido('mensajeAmpliado')) {
              <div class="text-danger small">El mensaje ampliado es obligatorio (máx. 500 caracteres).</div>
            }
          </div>

          <div class="mt-3">
            <label class="form-label">Enlace del pop-up (opcional)</label>
            <div class="row g-2">
              <div class="col-12 col-md-4">
                <label class="radio-card h-100" [class.selected]="tipoEnlace() === 'SIN_ENLACE'">
                  <input type="radio" class="visually-hidden" value="SIN_ENLACE" formControlName="enlaceTipo"
                         (change)="onTipoEnlaceCambio('SIN_ENLACE')">
                  <span class="radio-dot"><span class="radio-dot-fill"></span></span>
                  <span class="radio-card-body">
                    <span class="radio-card-title">Sin enlace</span>
                    <span class="radio-card-desc">Solo se cierra con la X.</span>
                  </span>
                </label>
              </div>
              <div class="col-12 col-md-4">
                <label class="radio-card h-100" [class.selected]="tipoEnlace() === 'EXTERNO'">
                  <input type="radio" class="visually-hidden" value="EXTERNO" formControlName="enlaceTipo"
                         (change)="onTipoEnlaceCambio('EXTERNO')">
                  <span class="radio-dot"><span class="radio-dot-fill"></span></span>
                  <span class="radio-card-body">
                    <span class="radio-card-title">Enlace externo</span>
                    <span class="radio-card-desc">Abre un sitio web fuera de la app.</span>
                  </span>
                </label>
              </div>
              <div class="col-12 col-md-4">
                <label class="radio-card h-100" [class.selected]="tipoEnlace() === 'SECCION_APP'">
                  <input type="radio" class="visually-hidden" value="SECCION_APP" formControlName="enlaceTipo"
                         (change)="onTipoEnlaceCambio('SECCION_APP')">
                  <span class="radio-dot"><span class="radio-dot-fill"></span></span>
                  <span class="radio-card-body">
                    <span class="radio-card-title">Sección de la app</span>
                    <span class="radio-card-desc">Lleva a un módulo de GEAMOVIL.</span>
                  </span>
                </label>
              </div>
            </div>

            @if (tipoEnlace() === 'EXTERNO') {
              <div class="mt-3">
                <label class="form-label">URL</label>
                <input type="url" class="form-control" placeholder="https://www.gea.com.ar/novedades" [attr.maxlength]="maxUrlEnlace"
                       formControlName="enlaceUrl">
                @if (mensajeErrorEnlaceBackend('url'); as mensaje) {
                  <div class="text-danger small">{{ mensaje }}</div>
                } @else if (esInvalido('enlaceUrl')) {
                  <div class="text-danger small">{{ form.get('enlaceUrl')?.errors?.['urlEnlace'] }}</div>
                }
              </div>
            }

            @if (tipoEnlace() === 'SECCION_APP') {
              <div class="mt-3">
                <label class="form-label">Sección de destino</label>
                <select class="form-select" formControlName="enlaceSeccion">
                  <option value="" disabled>Elegí una sección</option>
                  @for (s of seccionOpciones(); track s.id) {
                    <option [value]="s.id">{{ s.nombre }}</option>
                  }
                </select>
                @if (mensajeErrorEnlaceBackend('seccion'); as mensaje) {
                  <div class="text-danger small">{{ mensaje }}</div>
                } @else if (esInvalido('enlaceSeccion')) {
                  <div class="text-danger small">La sección de destino es obligatoria.</div>
                }
              </div>
            }

            @if (tieneEnlace()) {
              <div class="mt-3">
                <label class="form-label">Texto del botón</label>
                <input type="text" class="form-control" [attr.maxlength]="maxTextoBotonEnlace"
                       formControlName="enlaceTextoBoton">
                <div class="form-text text-end">{{ largoTextoBotonEnlace() }}/{{ maxTextoBotonEnlace }}</div>
                @if (mensajeErrorEnlaceBackend('textoBoton'); as mensaje) {
                  <div class="text-danger small">{{ mensaje }}</div>
                } @else if (esInvalido('enlaceTextoBoton')) {
                  <div class="text-danger small">{{ form.get('enlaceTextoBoton')?.errors?.['textoBotonEnlace'] }}</div>
                }
              </div>
            }
          </div>
        </div>
      </div>

      <div class="notif-card mb-3">
        <div class="notif-card-header">
          <span class="notif-step-num">3</span>
          <h2 class="notif-card-title">Calendario de entrega</h2>
        </div>

        @if (fechaEnvioReal()) {
          <div class="alert alert-secondary py-2 px-3 mb-3 small">
            Enviada el {{ formatearFechaEnvio(fechaEnvioReal()!) }}
            @if (cantidadDestinatarios() != null) {
              — a {{ cantidadDestinatarios() }} afiliados
            }
          </div>
        }

        <div class="row g-3">
          <div class="col-12">
            <div class="d-flex flex-column gap-2">
              <label class="radio-card" [class.selected]="!esProgramada()">
                <input type="radio" class="visually-hidden" value="INMEDIATA" formControlName="tipoEntrega">
                <span class="radio-dot"><span class="radio-dot-fill"></span></span>
                <span class="radio-card-body">
                  <span class="radio-card-title">Inmediatamente</span>
                  <span class="radio-card-desc">Se envía apenas confirmás en "{{ textoBoton() }}".</span>
                </span>
              </label>
              <label class="radio-card" [class.selected]="esProgramada()">
                <input type="radio" class="visually-hidden" value="PROGRAMADA" formControlName="tipoEntrega">
                <span class="radio-dot"><span class="radio-dot-fill"></span></span>
                <span class="radio-card-body">
                  <span class="radio-card-title">Hora específica</span>
                  <span class="radio-card-desc">Programá fecha y hora futuras. Mientras no se dispare, se puede editar o eliminar.</span>
                </span>
              </label>
            </div>
          </div>

          @if (esProgramada()) {
            <div class="col-12 col-md-3">
              <label class="form-label notif-label-2l">Fecha de envío</label>
              <input type="date" class="form-control" [min]="fechaMinimaParte" [disabled]="form.disabled"
                     [value]="fechaParte()" (change)="onFechaParteChange($any($event.target).value)">
            </div>
            <div class="col-12 col-md-3">
              <label class="form-label notif-label-2l">Hora de envío</label>
              <input type="time" class="form-control" [disabled]="form.disabled"
                     [value]="horaParte()" (change)="onHoraParteChange($any($event.target).value)">
            </div>
            @if (esInvalido('fechaProgramacion')) {
              <div class="col-12">
                <div class="text-danger small">
                  @if (form.get('fechaProgramacion')?.errors?.['required']) {
                    Ingresá la fecha y hora de programación.
                  } @else if (form.get('fechaProgramacion')?.errors?.['fechaNoFutura']) {
                    Tiene que ser una fecha y hora futura.
                  }
                </div>
              </div>
            }
          }
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2">
        @if (modo() === 'editar') {
          <button type="button" class="btn btn-outline-danger me-auto" [disabled]="guardando()" (click)="onEliminar()">
            Eliminar
          </button>
        }
        <button type="button" class="btn btn-notif-secondary" [disabled]="guardando()" (click)="onCancelar()">Cancelar</button>
        @if (modo() !== 'consulta') {
          <button type="button" class="btn btn-notif-primary" [disabled]="guardando() || !puedeGuardar()" (click)="onSubmit()">{{ textoBoton() }}</button>
        }
      </div>
    </div>

    <aside class="notif-nueva-preview">
      <app-notificacion-preview [titulo]="previewTitulo()" [mensajeCorto]="previewCorto()" [mensajeAmpliado]="previewAmpliado()"
                              [textoBotonEnlace]="previewTextoBotonEnlace()" [tipoEnlace]="tipoEnlace()"
                              [urlEnlace]="previewUrlEnlace()" [seccionNombre]="previewSeccionNombre()" />
    </aside>
    </div>
  </form>
</div>
